<script setup lang="ts">
import type { SearchAllPayload } from '@store'

definePageMeta({
  layout: 'search',
})

useSetSEO()
useScrollRestoration()

const { t } = useI18n()
const searchStore = useSearchStore()
const layoutStore = useLayoutStore()
const route = useRoute()
const isLoading = ref(false)
const isError = ref(false)

/**
 * 최초 랜딩시 쿼리 스트링에 검색어가 있을경우 스토어 업데이트
 */
if (route.query.keyword) {
  searchStore.updateKeyword(route.query.keyword as string)
}

/**
 * 최초 랜딩시 통합검색 목록 조회
 */
onMounted(() => {
  fetchSearchAll({ query: searchStore.keyword })
})

/**
 * 스토어의 검색어가 변경되면 통합검색 목록 조회
 */
watch(
  () => searchStore.keyword,
  async (cur) => {
    await fetchSearchAll({ query: cur })
  }
)

/**
 * 로딩 감지
 */
watch(
  () => isLoading.value,
  (cur) => {
    layoutStore.updateLoadingIndicatorGlobal({ show: cur })
  }
)

/**
 * 통합검색 목록 조회
 */
const fetchSearchAll = async (payload: SearchAllPayload) => {
  try {
    isLoading.value = true
    isError.value = false
    await searchStore.fetchSearchAll(payload)
  } catch (err) {
    isError.value = true
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <div class="page-search">
    <div v-if="!isLoading && searchStore.all" class="inner">
      <h4
        v-dompurify-html="
          t('statusMessages.search.success', { keyword: searchStore.keyword })
        "
        class="search-keyword"
      />

      <NovaSearchResult />
    </div>

    <NuxtPage />
  </div>
</template>

<style lang="scss" scoped>
.page-search {
  display: flex;
  gap: 40px;
  width: 100%;
  height: fit-content;

  > .inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: fit-content;

    .search-keyword {
      flex-shrink: 0;
      padding: 40px 0 20px;

      @include text-style($text-heading2-medium);

      :deep(strong) {
        @include text-style($text-heading2-bold);
      }
    }
  }

  @include mobile {
    > .inner {
      .search-keyword {
        padding: 30px 20px 20px;
      }
    }
  }
}
</style>
